import { Component, EventEmitter, Output } from '@angular/core';

import { QueovalDate, ActionCoActionCo, ActionCoCardModel, ActionCoContact, ActionCoDevisModel, ActionCoHistory, ActionCoHistoryType, ActionCoLDMModel, BObjectModel, CRUD, FileModel, Person, QueovalDateTime, Select, ActionCoLDMContexte, ActionCoMission } from '../../../models';
import { HttpService, CoreService, FilesManagerService, QueovalDateService, } from '../../../services';
import * as _ from 'lodash';
import { ToastService } from '../../../toast';

import { ActionCoService } from '../action-co-services/action-co.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HistoryService } from '../../../history';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-ldm',
  templateUrl: './action-co-ldm.component.html',
  styleUrls: ['./action-co-ldm.component.css', '../action-co-card.component.css', '../action-co-action/action-co-action.component.css', '../action-co-devis/action-co-devis.component.css',]
})

export class ActionCoLDMComponent {

  public ModelDevis: ActionCoDevisModel = new ActionCoDevisModel();
  public ModelLDM: ActionCoLDMModel = new ActionCoLDMModel();

  public clickedThumb: string = '';
  public ThumbBoTypeValue: string = '';
  public insertDocModel: BObjectModel;
  public modeBo: string = '';
  public relationMission: string = '';
  public idMission: string = '0';

  public Loaded: boolean = false;

  @Output() setIdActionCo: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
    public toast: ToastService,
    public actionCoService: ActionCoService,
    private fileService: FilesManagerService,
    private modalService: NgbModal,
    private qDateService: QueovalDateService,
    protected historyService: HistoryService
  ) { }


  public ngOnInit(): void {

    this.ModelLDM.Contexte.ActionCo = new ActionCoActionCo();
    this.ModelLDM.Contexte.ActionCo.Ident = this.actionCoService.Model.idActionCo;

    this.actionCoService.MissionAdd$.subscribe((bool: Boolean) => {
      this.http.getHttp<ActionCoLDMModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/LDM/GetMission/${this.actionCoService.Model.Customer.Id}|${this.actionCoService.Model.idActionCo}`).subscribe((data: ActionCoLDMModel) => {
        this.ModelLDM = data;
        this.Loaded = this.ModelLDM.ListMission.length > 0;
        if (!this.ModelLDM.Contexte) {
          this.ModelLDM.Contexte = new ActionCoLDMContexte();
        }
        this.ModelLDM.Contexte.Client = this.actionCoService.Model.Customer;


        //Selection automatique du contact principal de l'action co
        if (!this.ModelLDM.LDM.Ident || this.ModelLDM.LDM.Ident == '' || this.ModelLDM.LDM.Ident == '0') {
          const cntActionCo: any = this.ModelLDM.Contexte.ListContactPrincipal.find((cnt: ActionCoContact) => { return cnt.id == this.actionCoService.Model.ContactPrincipal.Id });
          if (cntActionCo) {
            cntActionCo.selected = true;
          }
        }
        this.insertDocModel = new BObjectModel();
        this.insertDocModel.IdDonneeFils = this.ModelLDM.LDM.Ident;
        this.insertDocModel.IdRelation = "REL_BO_CSOC_BO_LDM";
      });
    });
    this.actionCoService.OnMissionAdd();

    this.insertDocModel = new BObjectModel();
    this.insertDocModel.IdDonneeFils = this.ModelLDM.LDM.Ident;
    this.insertDocModel.IdRelation = "REL_BO_CSOC_BO_LDM";
  }


  public AddCnt(element: ActionCoContact): void {
    element.selected = true;
  }
  public RemoveCnt(element: ActionCoContact): void {
    element.selected = false;

  }
  public CheckListCnt(ListContact: Array<any>, selected: boolean = true): boolean {
    return selected ? ListContact.some(cnt => cnt.selected) : ListContact.some(cnt => !cnt.selected);
  }


  public GenererLDM() {

    if (this.ModelLDM.LDM.DevisSigne || this.ModelLDM.LDM.DevisPerdu || this.ModelLDM.LDM.ReadOnly) {
      return;
    }

    if (!this.ModelLDM.LDM.TypeDoc.id) {
        this.toast.showInfoToast("Aucun modèle de devis sélectionné. Veuillez sélectionner un modèle pour générer le document.");
        return;
      }
      this.indParam.showSplash(true);

      let ldmState: CRUD;
      if (!this.ModelLDM.LDM.Ident || this.ModelLDM.LDM.Ident == '0') {
        ldmState = CRUD.CREATE;
      } else {
        ldmState = CRUD.UPDATE;
      }
      // ident de l'action co (pour l'historique)
      this.ModelLDM.IdActionCo = this.actionCoService.Model.idActionCo;
      this.ModelLDM.Mode = 'SaveLDM';
      this.http.postHttp<ActionCoLDMModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/LDM`, this.ModelLDM).subscribe((data: ActionCoLDMModel) => {
        if (!data.HasError) {
          this.ModelLDM = data;
          this.actionCoService.OnDevisCreated(this.ModelLDM.LDM.Ident);
        }

        this.ModelDevis.Mode = 'GENERERDOCDEVIS';
        this.ModelDevis.Devis.Ident = this.ModelLDM.LDM.Ident;
        this.ModelDevis.ActionCo.Ident = this.ModelLDM.IdActionCo;
        this.ModelDevis.PersonneMorale = this.ModelLDM.Contexte.Client;
        this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, this.ModelDevis).subscribe((data: ActionCoDevisModel) => {
          this.ModelLDM.LDM.FileExist = data.Devis.FileExist;
          this.actionCoService.CanTransform();
          // pdf generer          
          this.indParam.showSplash(false);
          this.toast.showSuccessToast(`La lettre de mission: ${this.ModelLDM.LDM.Titre} a été générée.`);
          // mise à jour de l'historique
          this.historyService.GetHistory(this.actionCoService.Model.idActionCo).subscribe(() => { this.setIdActionCo.emit(this.actionCoService.Model.idActionCo); });
        });

      });
    }
 
  public OnCollaboChange(Collabo: Array<Person>): void { }

  public SelectChange(value: any, mode: string) {
    switch (mode) {
      case 'TYPEDOC':
        this.ModelLDM.LDM.TypeDoc = value;
        break;
      case 'DOSSIER':
        this.ModelLDM.LDM.Dossier = value;
        break;
    }
  }


  public DownloadDevis(extension: string) {
    const fileModel: FileModel = new FileModel();
    fileModel.Ident = this.ModelLDM.LDM.Ident;
    fileModel.Extension = extension;
    fileModel.Name = this.ModelLDM.LDM.Ident;
    fileModel.DownloadMode = 'DOCXGENERE';
    this.fileService.downloadFile(fileModel);

  }


  public openUploadDocument(content: any) {
    this.modalService.open(content, { size: 'xl', windowClass: 'qmodalover', centered: true }).result.then((result) => {
      switch (result) {
        // case 'SAVE': this.model.Devis.FileExist = true; break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }


  public BuildDate(value: QueovalDate): string {
    return this.qDateService.ToString(value, 'dd/MM/yyyy');
  }





  // Region Visualisation BO projet et devis
  public OnOpenBo() {
    this.modeBo = this.ModelLDM.Contexte.Client.IsClient ? 'PP_LDM' : 'PM_LDM';
  }

  public OnOpenBoMission(mission: ActionCoMission) {
    this.modeBo = 'MISSION';
    this.idMission = mission.Ident;
    this.relationMission = mission.Relation;

  }

  public OnCloseBo(value: any) {
    this.modeBo = '';

  }
}
